export const mergeClasses = (classes = []) =>
  classes
    .filter((element) => typeof element === "string" && element.trim() !== "")
    .join(" ");

export const isUrlWithScheme = (link) => {
  const regex = /^(http:\/\/|https:\/\/|ftp:\/\/|mailto:|file:\/\/)/;
  return regex.test(link);
};

export const formatDateLong = (dateString) => {
  let dateToParse = dateString;
  if (typeof dateString === "string" && dateString.indexOf("T") === -1) {
    dateToParse = `${dateString.trim()}T12:00:00-08:00`; // Assume noon PST
  }
  return new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Los_Angeles",
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(new Date(dateToParse));
};

export const formatISODate = (dateString) => {
  const date = new Date(dateString);
  return date.toISOString().split("T")[0];
};

export const formatISODateTime = (dateString) => {
  // Check if time is already present
  if (dateString.includes("T")) {
    return dateString; // Already has time info
  }
  // Default - Assume noon PST
  return `${dateString}T12:00:00-08:00`;
};
